import request from '@/utils/request';

// 获取二维码
export function getQrcode() {
  return request.get('/wxScan_api/wxLogin');
}
// 获取登录状态
export function getLoginStatus(pLoginKey) {
  return request.post('/wxScan_api/getWxLoginInfo', {
    loginKey: pLoginKey,
  });
}
// 扫码登录
export function scanLogin(pToken) {
  request.defaults.headers.token = pToken;
  return request.post('/dengLuHm/gogogo');
}
// 账号密码登录
export function inputLogin(pObj) {
  return request.post('/dengLuHm/gogogo', {
    phonenumber: pObj.phone,
    passwd: pObj.password,
  });
}

// 酒吧端注册
export function register(pObj) {
  return request.post('/dengLuHm/zhuceBar', {
    phonenumber: pObj.phone,
    passwd: pObj.password,
    invite_key: pObj.inviteCode,
    code: pObj.valiCode,
    token: pObj.ext,
    id: pObj.codeId,
  });
}

// 获取图形验证码
export function getGraphicCaptcha() {
  return request.post('/captchaHm/getGraphicCaptcha');
}

// 携带图形验证码发送短信验证码（注册 source=1 / 忘记密码 source=2）
export function sendSmsCodeWithCaptcha(pObj) {
  return request.post('/captchaHm/sendSmsCodeWithCaptcha', {
    phonenumber: pObj.phone,
    source: pObj.source,
    captchaId: pObj.captchaId,
    captchaCode: pObj.captchaCode,
  }).then((res) => {
    if (res.code === 200 && res.data) {
      return {
        code: res.data.code,
        msg: res.data.msg,
        data: res.data.data || {},
      };
    }
    return {
      code: String(res.code),
      msg: res.msg,
      data: {},
    };
  });
}

// 忘记密码 — 重置密码
export function resetPassword(pObj) {
  return request.post('/dengLuHm/updateMiMa', {
    phonenumber: pObj.phone,
    passwd: pObj.password,
    code: pObj.valiCode,
    id: pObj.codeId,
    token: pObj.ext,
  });
}

// 提交城市代理申请
export function submitAgentApplication(pObj) {
  return request.post('/dengLuHm/saveCommentInfo', {
    name: pObj.name,
    city: pObj.city,
    phone_number: pObj.phone_number,
    content: pObj.content,
  });
}
